import { Component, input, OnInit } from "@angular/core";
import { MatDivider } from "@angular/material/divider";

@Component({
  selector: "vl-divider",
  standalone: true,
  imports: [MatDivider],
  templateUrl: "./divider.component.html",
  styleUrls: ["./divider.component.scss"],
})
export class DividerComponent implements OnInit {
  label = input<string>();
  offset = input<"big" | "small" | "none">("big");

  constructor() {}

  ngOnInit(): void {}
}
